$(document).ready(function () {
	$('.to-product-reviews').click(function () {
		let self = this;

		setTimeout(function () {
			let href = $(self).attr('href');
			let $scollTo = $(href);

			let $toTab = $('.product-to-tab-reviews');
			$toTab.tab('show');

			$([document.documentElement, document.body]).animate({
				scrollTop: $scollTo.offset().top - 150
			}, 50);
		}, 10);
	})
})